// extracted by mini-css-extract-plugin
module.exports = {"button":"_105329b597--button--goD0Y","icon":"_105329b597--icon--QA8y7"};